// frontend/modules/customer-loan-info/index.ts
import { ModuleConfig } from '@/core/module';
import { customerLoanInfoRoutes } from './routes';
import { useCustomerLoanInfoStore } from './stores/customer-loan-info-store';

/**
 * Customer Loan Information module definition
 */
export const CustomerLoanInfoModule: ModuleConfig = {
  name: 'customer-loan-info',
  routes: customerLoanInfoRoutes,
  stores: {
    customerLoanInfo: useCustomerLoanInfoStore
  },
  
  // Initialization logic
  initialize: () => {
    console.log('Customer Loan Information module initialized');
  },
  
  // Cleanup logic
  cleanup: () => {
    console.log('Customer Loan Information module cleanup');
  }
};
